<div class="profile-wrapper" >
    <div class="profile-header">
        <div class="profile-avatar">
            <app-avatar *ngIf="userProfile"
                    [profile]="userProfile"
                    [detailProfile]="true"
                    [size]="'full'"
                    (hasAvatar)="hasAvatar = $event"
            ></app-avatar>
        </div>
        <div class="profile-info" *ngIf="userProfile">
            <p>  <b>{{ 'USER_PROFILE.TEXT.LASTNAME' | translate }}: </b>   {{ userProfile?.lastname }} </p>
            <p> <b>{{ 'USER_PROFILE.TEXT.FIRSTNAME' | translate }}: </b>    {{ userProfile.firstname }} </p>
            <p> <b>{{ 'USER_PROFILE.TEXT.MIDDLENAME' | translate }}: </b>{{ userProfile.middlename }} </p>
            <p> <b>{{ 'USER_PROFILE.TEXT.EMAIL' | translate }}: </b> {{ userProfile.email }} </p>
            <p>  <b>{{ 'USER_PROFILE.TEXT.PHONE' | translate }}: </b>{{ userProfile.phone }}</p>
            <p> <b>{{ 'USER_PROFILE.ROLE.ROLE' | translate }}: </b>{{ 'USER_PROFILE.ROLE.' + userProfile.project_setting.observation_type | translate }}</p>
             <p> <b>{{ 'USER_PROFILE.TEXT.POSITION' | translate }}: </b>{{ userProfile.project_setting.position }}</p>
        </div>
    </div>
    <div class="profile-buttons">
      <button  class="button-icon secondary-button size-l" [routerLink]="['/', 'account', 'options', 'profile']" >
         <mat-icon svgIcon="user-settings-line" class="profile-buttons-icon"></mat-icon>
        {{ 'USER_PROFILE.TEXT.PROFILE'|translate }}
      </button>
      <button  class="button-icon secondary-button size-l"  (click)="selectCompany()"  data-action="selectCompany">
         <mat-icon svgIcon="briefcase-line" class="profile-buttons-icon"></mat-icon>
        {{ 'USER_PROFILE.CHANGE_PROJECT' | translate }}
      </button>
      <button class="button-icon secondary-button size-l"  (click)="logout()"  data-action="logout" >
         <mat-icon matPrefix svgIcon="logout-box-r-line" class="profile-buttons-icon"></mat-icon>
        {{ 'EXIT' | translate }}
      </button>
    </div>
</div>
